import { render, staticRenderFns } from "./AssociatePerformanceChartContainer.vue?vue&type=template&id=22e2cdc8&scoped=true&"
import script from "./AssociatePerformanceChartContainer.vue?vue&type=script&lang=js&"
export * from "./AssociatePerformanceChartContainer.vue?vue&type=script&lang=js&"
import style0 from "./AssociatePerformanceChartContainer.vue?vue&type=style&index=0&id=22e2cdc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e2cdc8",
  null
  
)

export default component.exports